import React from "react";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'
import { UpdateParameterValues } from "../services/City";
function FinancingD(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
  const [structureType, SetstructureType] = React.useState("Per Home");
  const [IsReadOnly, SetReadOnly] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(null);

  React.useEffect(() => {



    if (props.id == 276) {
      if (props.object["Site Potential"].find((item) => item.ParameterId == 1000 && item.structureType == props.structureType)) {
        // document.getElementById("290-"+props.structureType+"-btn").style.display = "none";
        // document.getsElementById("289-"+props.structureType+"-btn").style.display = "none";

        var structuretype = props.structureType;
        var isDefault = props.object["Site Potential"].find((item) => item.ParameterId == 1000 && item.structureType == props.structureType).value;
        var isDefault1 = props.object["Site Potential"].find((item) => item.ParameterId == 1000 && item.structureType == props.structureType).perhomevalue;

        if ((isDefault1 != "55")) {
          if (isDefault == "true") {
            // Retrieve all input elements within the div

            // document.getElementById("290-"+props.structureType+"-btn").style.display = "initial";
            // document.getElementById("289-"+props.structureType+"-btn").style.display = "initial";

            var elements = document.getElementsByClassName('adminDefault')
            for (var i = 0; i < elements.length; i++) {
              elements[i].style.display = 'none';
            }
            var elements1 = document.getElementsByClassName('UserDefault')

            for (var i = 0; i < elements1.length; i++) {
              elements1[i].style.display = 'inherit';
            }
            var elements2 = document.getElementsByClassName('Defsoftcost1')
            for (var i = 0; i < elements2.length; i++) {
              elements2[i].style.display = 'initial';
            }
            var elements3 = document.getElementsByClassName('Defhardcost1')
            for (var i = 0; i < elements3.length; i++) {
              elements3[i].style.display = 'initial';
            }
            // var ss=document.getElementById(props.structureType+"-All");
            // ss.style.display="inherit";
            var divElement = document.querySelector('.Tab-' + structuretype.replace(/\s/g, ""));
            var inputElements = divElement.querySelectorAll('input');

            // Iterate over each input element and set the readOnly property
            for (var i = 0; i < inputElements.length; i++) {
              inputElements[i].readOnly = false;
            }

          }
          else {
            var elements = document.getElementsByClassName('adminDefault')
            for (var i = 0; i < elements.length; i++) {
              elements[i].style.display = 'inherit';
            }
            var elements1 = document.getElementsByClassName('UserDefault')

            for (var i = 0; i < elements1.length; i++) {
              elements1[i].style.display = 'none';
            }
            var elements2 = document.getElementsByClassName('Defsoftcost1')
            for (var i = 0; i < elements2.length; i++) {
              elements2[i].style.display = 'none';
            }
            var elements3 = document.getElementsByClassName('Defhardcost1')
            for (var i = 0; i < elements3.length; i++) {
              elements3[i].style.display = 'none';
            }
            // var ss=document.getElementById(props.structureType+"-All");
            // ss.style.display="inherit";
            var divElement = document.querySelector('.Tab-' + structuretype.replace(/\s/g, ""));
            var inputElements = divElement.querySelectorAll('input');

            // Iterate over each input element and set the readOnly property
            for (var i = 0; i < inputElements.length; i++) {
              inputElements[i].readOnly = true;
            }
          }
        }

        else if (isDefault1 == "55") {
          if (isDefault == "false") {
            var elements = document.getElementsByClassName('adminDefault')
            for (var i = 0; i < elements.length; i++) {
              elements[i].style.display = 'inherit';
            }
            var elements1 = document.getElementsByClassName('UserDefault')

            for (var i = 0; i < elements1.length; i++) {
              elements1[i].style.display = 'none';
            }
            var elements2 = document.getElementsByClassName('Defsoftcost1')
            for (var i = 0; i < elements2.length; i++) {
              elements2[i].style.display = 'none';
            }
            var elements3 = document.getElementsByClassName('Defhardcost1')
            for (var i = 0; i < elements3.length; i++) {
              elements3[i].style.display = 'none';
            }
            // var ss=document.getElementById(props.structureType+"-All");
            // ss.style.display="inherit";
            var divElement = document.querySelector('.Tab-' + structuretype.replace(/\s/g, ""));
            var inputElements = divElement.querySelectorAll('input');

            // Iterate over each input element and set the readOnly property
            for (var i = 0; i < inputElements.length; i++) {
              inputElements[i].readOnly = true;
            }
          }
          else if (isDefault == "true") {
            var elements = document.getElementsByClassName('adminDefault')
            for (var i = 0; i < elements.length; i++) {
              elements[i].style.display = 'none';
            }
            var elements1 = document.getElementsByClassName('UserDefault')

            for (var i = 0; i < elements1.length; i++) {
              elements1[i].style.display = 'inherit';
            }
            var elements2 = document.getElementsByClassName('Defsoftcost1')
            for (var i = 0; i < elements2.length; i++) {
              elements2[i].style.display = 'initial';
            }
            var elements3 = document.getElementsByClassName('Defhardcost1')
            for (var i = 0; i < elements3.length; i++) {
              elements3[i].style.display = 'initial';
            }
            // var ss=document.getElementById(props.structureType+"-All");
            // ss.style.display="inherit";
            var divElement = document.querySelector('.Tab-' + structuretype.replace(/\s/g, ""));
            var inputElements = divElement.querySelectorAll('input');

            // Iterate over each input element and set the readOnly property
            for (var i = 0; i < inputElements.length; i++) {
              inputElements[i].readOnly = false;
            }
          }
        }
        // if(isDefault1=="55" && isDefault=="true"){


        //   var divElement = document.querySelector('.Tab-'+structuretype.replace(/\s/g, ""));
        //   var inputElements = divElement.querySelectorAll('input');

        //   // Iterate over each input element and set the readOnly property
        //   for (var i = 0; i < inputElements.length; i++) {

        //     inputElements[i].readOnly = true;
        //   }

        //   var elements = document.getElementsByClassName('adminDefault')
        //   for (var i = 0; i < elements.length; i++){
        //       elements[i].style.display = 'inherit';
        //   }
        //   var elements1 = document.getElementsByClassName('UserDefault')

        //   for (var i = 0; i < elements1.length; i++){
        //       elements1[i].style.display = 'none';
        //   }
        //   var elements2 = document.getElementsByClassName('Defsoftcost1')
        //   for (var i = 0; i < elements2.length; i++){
        //       elements2[i].style.display = 'none';
        //   }
        //   var elements3 = document.getElementsByClassName('Defhardcost1')
        //   for (var i = 0; i < elements3.length; i++){
        //       elements3[i].style.display = 'none';
        //   }
        // }
        // else{
        //   var elements = document.getElementsByClassName('adminDefault')
        //   for (var i = 0; i < elements.length; i++){
        //       elements[i].style.display = 'none';
        //   }
        //   var elements1 = document.getElementsByClassName('UserDefault')

        //   for (var i = 0; i < elements1.length; i++){
        //       elements1[i].style.display = 'inherit';
        //   }
        //   var elements2 = document.getElementsByClassName('Defsoftcost1')
        //   for (var i = 0; i < elements2.length; i++){
        //       elements2[i].style.display = 'initial';
        //   }
        //   var elements3 = document.getElementsByClassName('Defhardcost1')
        //   for (var i = 0; i < elements3.length; i++){
        //       elements3[i].style.display = 'initial';
        //   }
        //   // var ss=document.getElementById(props.structureType+"-All");
        //   // ss.style.display="inherit";
        //   var divElement = document.querySelector('.Tab-'+structuretype.replace(/\s/g, ""));
        //   var inputElements = divElement.querySelectorAll('input');

        //   // Iterate over each input element and set the readOnly property
        //   for (var i = 0; i < inputElements.length; i++) {
        //     inputElements[i].readOnly = false;
        //   }
        // }
      }

    }
    //   if(props.object["Site Potential"].find((item) => item.ParameterId == 1001 && item.structureType==props.structureType))
    // {


    //     if(props.id==276)
    //     {
    //       var toogle = document.getElementById(props.structureType+"-1001-L");
    //       var ischecked =toogle.checked;

    //       var structuretype=props.structureType;
    //       //var isDefault=props.object["Site Potential"].find((item) => item.ParameterId == 1000 && item.structureType==props.structureType).value;
    //       //var isDefault1=props.object["Site Potential"].find((item) => item.ParameterId == 1000 && item.structureType==props.structureType).perhomevalue;

    //      // if((isDefault1=="55" || isDefault1!="55") && isDefault1=="true"){
    //       if(ischecked=="true")
    //       {


    //         // Retrieve all input elements within the div

    //         document.getElementById("290-"+props.structureType+"-btn").style.display = "none";
    //         document.getElementById("289-"+props.structureType+"-btn").style.display = "none";

    //         var elements = document.getElementsByClassName('adminDefault')
    //         for (var i = 0; i < elements.length; i++){
    //             elements[i].style.display = 'inherit';
    //         }
    //         var elements1 = document.getElementsByClassName('UserDefault')

    //         for (var i = 0; i < elements1.length; i++){
    //             elements1[i].style.display = 'none';
    //         }
    //         var elements2 = document.getElementsByClassName('Defsoftcost1')
    //         for (var i = 0; i < elements2.length; i++){
    //             elements2[i].style.display = 'none';
    //         }
    //         var elements3 = document.getElementsByClassName('Defhardcost1')
    //         for (var i = 0; i < elements3.length; i++){
    //             elements3[i].style.display = 'none';
    //         }
    //         var ss=document.getElementById(props.structureType+"-All");
    //         ss.style.display="none";

    //         var divElement = document.querySelector('.Tab-'+structuretype.replace(/\s/g, ""));
    //         var inputElements = divElement.querySelectorAll('input');

    //         // Iterate over each input element and set the readOnly property
    //         for (var i = 0; i < inputElements.length; i++) {

    //           inputElements[i].readOnly = true;
    //         }

    //       }
    //       if(ischecked=="false")
    //       {
    //         // Retrieve all input elements within the div

    //         document.getElementById("290-"+props.structureType+"-btn").style.display = "initial";
    //         document.getElementById("289-"+props.structureType+"-btn").style.display = "initial";

    //         var elements = document.getElementsByClassName('adminDefault')
    //         for (var i = 0; i < elements.length; i++){
    //             elements[i].style.display = 'none';
    //         }
    //         var elements1 = document.getElementsByClassName('UserDefault')

    //         for (var i = 0; i < elements1.length; i++){
    //             elements1[i].style.display = 'inherit';
    //         }
    //         var elements2 = document.getElementsByClassName('Defsoftcost1')
    //         for (var i = 0; i < elements2.length; i++){
    //             elements2[i].style.display = 'initial';
    //         }
    //         var elements3 = document.getElementsByClassName('Defhardcost1')
    //         for (var i = 0; i < elements3.length; i++){
    //             elements3[i].style.display = 'initial';
    //         }
    //         var ss=document.getElementById(props.structureType+"-All");
    //         ss.style.display="inherit";
    //         var divElement = document.querySelector('.Tab-'+structuretype.replace(/\s/g, ""));
    //         var inputElements = divElement.querySelectorAll('input');

    //         // Iterate over each input element and set the readOnly property
    //         for (var i = 0; i < inputElements.length; i++) {
    //           inputElements[i].readOnly = false;
    //         }

    //       }
    //     //}
    //     }
    //   }
    if (props.IsManual == 1) {
      SetReadOnly(true);
    }
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.id == 266 || props.id == 267) {
      SetStyle("form-control construction Prowidth");
    }

    if (props.id == 271 || props.id == 272 || props.id == 273) {
      if (props.id == 271) {
        if (props.value == "false") {
          setIsChecked(false);

          var parentDiv = document.getElementById("loan");
          var childDivs = parentDiv.getElementsByTagName("div");

          for (var i = 3; i < childDivs.length; i++) {

            childDivs[i].style.display = "none";
          }
        }
        else setIsChecked(true);
      }
      if (props.id == 272) {
        if (props.value == "false") {
          setIsChecked(false);

          var parentDiv = document.getElementById("cons");
          var childDivs = parentDiv.getElementsByTagName("div");

          for (var i = 3; i < childDivs.length; i++) {

            childDivs[i].style.display = "none";
          }
        }
        else setIsChecked(true);
      }
      if (props.id == 273) {
        if (props.value == "false") {
          setIsChecked(false);

          var parentDiv = document.getElementById("ext");
          var childDivs = parentDiv.getElementsByTagName("div");

          for (var i = 3; i < childDivs.length; i++) {

            childDivs[i].style.display = "none";
          }
        }
        else setIsChecked(true);
      }
    }

    if (props.value == "") {
      // setValue(0);
    }
    else {
      setValue(props.value);
    }


    if (props.wholeEl.ischecked === true) {
      var pclass = IsStyle;
      SetStyle(pclass + " ischecked");
    }
    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);
  }, []);




  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";

    setchecked(e.target.checked);
    setchecked1(e.target.checked);

    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }



    document.getElementById(checkid).style.background = "#e7f0fa";
    if (checkid.includes("269")) {
      props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Financing"].find((item) => item.ParameterId == 266 && item.structureType == structuretype).ischecked = false;
      props.object["Financing"].find((item) => item.ParameterId == 266 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-266").style.background = "#f7fafd";
      document.getElementById(structuretype + "-266").value = 0;
    }
    if (checkid.includes("266")) {
      props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Financing"].find((item) => item.ParameterId == 269 && item.structureType == structuretype).ischecked = false;
      props.object["Financing"].find((item) => item.ParameterId == 269 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-269").style.background = "#f7fafd";
      document.getElementById(structuretype + "-269").value = 0;
    }
    if (checkid.includes("270")) {
      props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Financing"].find((item) => item.ParameterId == 267 && item.structureType == structuretype).ischecked = false;
      props.object["Financing"].find((item) => item.ParameterId == 267 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-267").value = 0
    }
    if (checkid.includes("267")) {
      props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Financing"].find((item) => item.ParameterId == 270 && item.structureType == structuretype).ischecked = false;
      props.object["Financing"].find((item) => item.ParameterId == 270 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-270").style.background = "#f7fafd";
      document.getElementById(structuretype + "-270").value = 0;
    }
    else {
      props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;

    }
    props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = e.target.value;
    document.getElementById(structuretype + "-All-Def").click();
    // var formID=0;
    // let newArr =[];
    //   newArr=({
    //    ParameterId: parameterid,ParameterName: props.name,ParameterTypeId:props.ParameterTypeId,value: e.target.value,
    //    ischecked: 1,structureType: structuretype,IsManual: 0,isComplete: 0,perhomevalue: 0,perprojectvalue: 0, ParamOrder: 0,
    //  });

    //  var name=Cookies.get('username');
    //  let params = {
    //   username: name,
    //   Stage:"P",
    //   formId: formID,
    //   userType:"AutoSave",
    //   parameters: []
    //  };
    //  params.StructureTypes=[{
    //   StructureType: structuretype,
    //   Calculations: [newArr],}
    //  ]
    //  params = JSON.stringify({
    //    Body: params,
    //  });
    //  console.log(params)
    //  return axios
    //    .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
    //      headers: {
    //        "Content-Type": "application/json",
    //        Accept: "application/json",
    //      },
    //      crossorigin: true,
    //    })
    //    .then((res) => {
    //    // setLoading(false);
    //    console.log("here")
    //      return res.data;
    //    })
    //    .catch((e) => {
    //    // setLoading(false);
    //      alert(e.message);
    //    });  
  };

  const onChange1 = (e) => {

    setIsChecked(!isChecked);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = checkid.split('-')[0];

    if (e.target.checked == true) {
      setValue("checked");

      if (parameterid == 271) {
        document.getElementById(structuretype + "-56").readOnly = false;
        document.getElementById(structuretype + "-266").readOnly = false;
        document.getElementById(structuretype + "-269").readOnly = false;
        document.getElementById(structuretype + "-57").readOnly = false;
        document.getElementById(structuretype + "-81").readOnly = false;
        document.getElementById(structuretype + "-56").readOnly = false;

        var parentDiv = document.getElementById("loan");
        var childDivs = parentDiv.getElementsByTagName("div");

        for (var i = 3; i < childDivs.length; i++) {

          childDivs[i].style.display = "inline-block";
        }

        // props.object["Financing"].find((item) => item.ParameterId == 56 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 266 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 269 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 57 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 263 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 264 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 81 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 58 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 179 && item.structureType==structuretype).value="0";

        // props.object["Financing"].find((item) => item.ParameterId == 56 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 266 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 269 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 57 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 263 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 264 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 81 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 58 && item.structureType==structuretype).ischecked=true;
        // props.object["Financing"].find((item) => item.ParameterId == 179 && item.structureType==structuretype).ischecked=true;
      }

      if (parameterid == 272) {
        document.getElementById(structuretype + "-61").readOnly = false;
        document.getElementById(structuretype + "-270").readOnly = false;
        document.getElementById(structuretype + "-267").readOnly = false;
        document.getElementById(structuretype + "-59").readOnly = false;
        document.getElementById(structuretype + "-60").readOnly = false;
        document.getElementById(structuretype + "-211").readOnly = false;
        document.getElementById(structuretype + "-274").readOnly = false;
        document.getElementById(structuretype + "-275").readOnly = false;

        var parentDiv = document.getElementById("cons");
        var childDivs = parentDiv.getElementsByTagName("div");

        for (var i = 3; i < childDivs.length; i++) {

          childDivs[i].style.display = "inline-block";
        }


      }
      if (parameterid == 273) {
        document.getElementById(structuretype + "-64").readOnly = false;
        document.getElementById(structuretype + "-265").readOnly = false;
        document.getElementById(structuretype + "-277").readOnly = false;
        document.getElementById(structuretype + "-276").readOnly = false;
        var parentDiv = document.getElementById("ext");
        var childDivs = parentDiv.getElementsByTagName("div");

        for (var i = 3; i < childDivs.length; i++) {

          childDivs[i].style.display = "inline-block";
        }

      }
      //props.setData({...props.wholeEl,value : "true",ischecked:true});
      props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = "true";

    }
    else {

      setValue("");

      if (parameterid == 271) {
        document.getElementById(structuretype + "-56").readOnly = true;
        document.getElementById(structuretype + "-266").readOnly = true;
        document.getElementById(structuretype + "-269").readOnly = true;
        document.getElementById(structuretype + "-57").readOnly = true;
        document.getElementById(structuretype + "-81").readOnly = true;

        document.getElementById(structuretype + "-56").style.background = "tranparent !important";


        var parentDiv = document.getElementById("loan");
        var childDivs = parentDiv.getElementsByTagName("div");

        for (var i = 3; i < childDivs.length; i++) {

          childDivs[i].style.display = "none";
        }
        //   document.getElementById(structuretype+"-148").readOnly = false;
        // props.object["Financing"].find((item) => item.ParameterId == 56 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 176 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 226 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 263 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 266 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 179 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 269 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 57 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 264 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 81 && item.structureType==structuretype).value="0";
        // props.object["Financing"].find((item) => item.ParameterId == 58 && item.structureType==structuretype).value="0";
      }
      if (parameterid == 272) {
        document.getElementById(structuretype + "-61").readOnly = true;
        document.getElementById(structuretype + "-270").readOnly = true;
        document.getElementById(structuretype + "-267").readOnly = true;
        document.getElementById(structuretype + "-59").readOnly = true;
        document.getElementById(structuretype + "-60").readOnly = true;
        document.getElementById(structuretype + "-211").readOnly = true;
        document.getElementById(structuretype + "-274").readOnly = true;
        document.getElementById(structuretype + "-275").readOnly = true;
        var parentDiv = document.getElementById("cons");
        var childDivs = parentDiv.getElementsByTagName("div");

        for (var i = 3; i < childDivs.length; i++) {

          childDivs[i].style.display = "none";
        }

      }
      if (parameterid == 273) {
        document.getElementById(structuretype + "-64").readOnly = true;
        document.getElementById(structuretype + "-265").readOnly = true;
        document.getElementById(structuretype + "-277").readOnly = true;
        document.getElementById(structuretype + "-276").readOnly = true;
        var parentDiv = document.getElementById("ext");
        var childDivs = parentDiv.getElementsByTagName("div");

        for (var i = 3; i < childDivs.length; i++) {

          childDivs[i].style.display = "none";
        }
      }
      //props.setData({...props.wholeEl,value : "false",ischecked:true});
      props.object["Financing"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = "false";

    }
    UpdateParameterValues(structuretype, props);

  };
  // if( props.id==270 || props.id==269 )
  // {
  //   return (
  //     <>
  //     <div class="col-md-2"  style={{marginTop:"1%",paddingRight:"0px",paddingLeft:"0px"}}>

  //     <label class=" financinglable ">{props.name.split('Per')[0]}      
  //         </label>



  //   </div>
  //     <div class="col-md-3" style={{marginTop:"1%"}}>
  //     <div class="from   justify-content-between  align-items-center ">
  //     <div class="test">
  //     <input
  //       type="text"
  //      key={props.structureType +"-"+ props.id}
  //      id={props.structureType +"-"+ props.id}
  //       value={value}
  //      onChange={onChange}
  //       //placeholder={props.name.split('Per')[0]}
  //       readOnly={IsReadOnly}
  //       class={IsStyle}

  //     />
  //     </div>
  //   </div>
  //   </div>
  //   </>
  // );
  //   }
  if (props.id == 277) {
    return (
      <>
        <div class="col-md-5 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
          <div class="from   justify-content-between  align-items-center ">
            <label class=" financinglable ">{props.name.split('Per')[0]}
            </label>



          </div>
        </div>
        <div class="col-md-2 col-6" style={{ marginTop: "1%" }}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test1">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly={IsReadOnly}
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }

  if (props.id == 274) {

    return (
      <>
        <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
          <div class="from   justify-content-between  align-items-center ">
            <label class=" financinglable ">{props.name.split('Per')[0]}
            </label>



          </div>
        </div>
        <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly={IsReadOnly}
                class={IsStyle}

              />
            </div>
          </div>
        </div>
        <div class="col-md-6" style={{ marginTop: "1%" }}></div>
      </>
    );
  }

  if (props.id == 266 || props.id == 267) {
    return (
      <>
        <div class="col-md-1 col-2" style={{ marginTop: "1%", padding: "0px", marginRight: "2%", marginLeft: "-2%" }}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test2">
              <input
                style={{ paddingLeft: "1.5em", paddingRight: "0em" }}
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly={IsReadOnly}
                class={IsStyle}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 65) {
    return (
      <>
        <div class="row" style={{ width: "100%" }}>
          <div class="col-md-3"></div>
          <div class="col-md-9" style={{ marginTop: "2%", borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}></div >
        </div>
        <div class="row" style={{ width: "100%" }}>

          <div class="col-md-5" style={{ marginTop: "1%" }}></div>
          <div class="col-md-4 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </div>

        <div class="row" style={{ marginTop: "2%" }}>
          <p style={{ width: "98%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>(Total Loan Amount * % of remaining loan amount * Loan Origination Fee) + (Total Loan Amount * % of remaining loan amount) * (Months of Extension Loan * Interest Rate) = Extension Loan Cost

          </p>
        </div>
      </>
    );
  }
  if (props.id == 58) {
    return (
      <>
        <div class="row" style={{ width: "100%" }}>
          <div class="col-md-3"></div>
          <div class="col-md-9" style={{ marginTop: "2%", borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}></div >
        </div>
        <div class="row" style={{ width: "100%" }}>

          <div class="col-md-5" style={{ marginTop: "1%" }}></div>
          <div class="col-md-4 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </div>

        <div class="row" style={{ marginTop: "2%" }}>
          <p class="col-md-12" style={{ width: "100%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>(Total Loan Amount * Carrying Month/12 * Interest Rate) + (Total Loan Amount + Loan Origination Fee) = Land Acquisition Loan Cost
          </p>
        </div>
      </>
    );
  }
  if (props.id == 62) {
    return (
      <>
        <div class="row" style={{ width: "100%" }}>
          <div class="col-md-3"></div>
          <div class="col-md-9" style={{ marginTop: "2%", borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}></div >
        </div>
        <div class="row" style={{ width: "100%" }}>

          <div class="col-md-5" style={{ marginTop: "1%" }}></div>
          <div class="col-md-4 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </div>

        <div class="row" style={{ marginTop: "2%" }}>
          <p style={{ width: "98%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>(Total Loan Amount * Avg.Loan * Interest Rate * Months to Build/12) + (Total Loan Amount * Loan Origination Fee) + (Cost * Amount of Draws) = Construction Loan Cost
          </p>
        </div>
      </>
    );
  }
  if (props.id == 66) {
    return (
      <>

        <div class="row" style={{ width: "101%" }}>

          <div class="col-md-5" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}></div>
          <div class="col-md-4 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 265 || props.id == 276) {
    return (
      <>
        <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
          <div class="from   justify-content-between  align-items-center ">
            <label class=" financinglable ">{props.name.split('Per')[0]}
            </label>



          </div>
        </div>
        <div class="col-md-2 col-6" style={{ marginTop: "1%" }}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test1">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly={IsReadOnly}
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 263 || props.id == 268 || props.id == 4227) {
    if (props.id == 4227) {
      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (
        <>
          <div class="col-md-2 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 179 || props.id == 264 || props.id == 178 || props.id == 212 || props.id == 213 || props.id == 64) {
    if (props.id == 212 || props.id == 213) {
      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test1">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (props.id == 64) {
      return (
        <>
          <div class="col-md-5 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-2 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div >
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 271 || props.id == 272 || props.id == 273) {
    return (
      <div class="row mb-1" style={{ width: "100%", alignItems: "center" }}>

        <div class="col-md-10" style={{ marginLeft: "2.5%" }}><span >{props.name.split('Per')[0]}</span></div>
      </div>
    );
  }
  else {
    if (props.id == 81 || props.id == 211) {

      return (
        <>
          <div class="col-md-2 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test1">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    }
    if (props.id == 57 || props.id == 59 || props.id == 60) {

      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test1">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly={IsReadOnly}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    }
    else {
      if (props.id == 56 || props.id == 64 || props.id == 61 || props.id == 275) {
        return (
          <>
            <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
              <div class="from   justify-content-between  align-items-center ">
                <label class=" financinglable ">{props.name.split('Per')[0]}
                </label>



              </div>
            </div>
            <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
              <div class="from   justify-content-between  align-items-center ">
                <div >
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    readOnly={IsReadOnly}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>
            <div class="col-md-3  col-5" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
              <div class="from   justify-content-between  align-items-center ">
                <label class=" financinglable ">{props.name.split('Per')[0]}
                </label>



              </div>
            </div>
            <div class="col-md-3 col-5" style={{ marginTop: "1%" }}>
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    readOnly={IsReadOnly}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  }
}
export default FinancingD;
